import React, { useCallback } from "react";
import { InspectionType } from "../../utils/enums";
import "./style.css";

// component for rendering pickup and dropoff tab options in upper left corner.
// clicking will switch back and forth between showing pickup and dropoff BOL data in the BOL document
const Tabs = ({ inspectionType, setInspectionType, vehicleData }) => {
  const getActiveClass = useCallback(
    type =>
      inspectionType === type ? "tabRow__tab--active" : "tabRow__tab--inactive",
    [inspectionType],
  );

  const hasPickup = (vehicleData || []).some(
    inspection => inspection.type === InspectionType.Pickup,
  );

  const hasDropOff = (vehicleData || []).some(
    inspection => inspection.type === InspectionType.DropOff,
  );

  return (
    <>
      <div className="tabRow">
        {hasPickup && (
          <span
            onClick={() => setInspectionType(InspectionType.Pickup)}
            className={`tabRow__tab ${getActiveClass(InspectionType.Pickup)}`}>
            Pickup
          </span>
        )}
        {hasDropOff && (
          <span
            onClick={() => setInspectionType(InspectionType.DropOff)}
            className={`tabRow__tab ${getActiveClass(InspectionType.DropOff)}`}>
            Dropoff
          </span>
        )}
      </div>
    </>
  );
};

export default Tabs;
